function CountDownShopify() {}
CountDownShopify.prototype.initAll = function (items) {
    if (items) {
        this.initCountDownGrid(items);
    } else {
        this.initCountDownGrid();
    }
}

CountDownShopify.prototype.initCountDownGrid = function (items) {
    var selector = ".grid__item .nt-countdown .countdown-inner > div";
    if (items) {
        var arrayItem = [];
        items.forEach(function (item) {
            var selectItem = $(item).find(selector)[0];
            if (selectItem) {
                arrayItem.push(selectItem);
            }
        });
        selector = arrayItem;
    }
    $(selector).each(function (index) {
        var data = $(this).attr('data');
        $(this).countdown(data, function (evt) {
            $(this).html(evt.strftime(
              ''+
                                              '<div><span>%D</span> days</div>'+
                                              '<div><span>%H</span> hours</div>'+
                                              '<div><span>%M</span> mins</div>'+
                                              '<div><span>%S</span> secs</div>'
            ));
        });
    });
}
